import React, {useState} from 'react';
import styles from './ShareDropdown.scss';
import {getEmailShareLink, getFacebookShareLink, getTwitterShareLink} from '../../lib/share';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import CloseIcon from '@material-ui/icons/Close';
import LinkIcon from '@material-ui/icons/Link';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import {propertyViewTracker} from '../../lib/tracking';
import withStyles from '@material-ui/core/styles/withStyles';
import {Tooltip} from '@material-ui/core';
import PropTypes from 'prop-types';


const StyledTooltip = withStyles({
  popper: {
    marginTop: '-15px',
    '@media (max-width:768px)': {
      marginTop: '-25px',
    },
    zIndex: 4001
  },
})(Tooltip);

const ShareDropdown = React.forwardRef((props, ref) => {
  const [isCopyLinkTooltipVisible, setIsCopyLinkTooltipVisible] = useState(false);

  const {
    open,
    onCloseHandler,
    property,
    pathname,
    isFromCollection,
    collectionName,
  } = props;

  const host = typeof window !== 'undefined' && window.location.host;

  let othShareUrl = isFromCollection ? `https://${host}${pathname}` : `https://www.onthehouse.com.au${pathname}`;

  const getSharePopupTitle = (propertyStatus) => {
    if (propertyStatus === 'SaleListing' || propertyStatus === 'RentalListing') {
      return 'Share this listing';
    }
    return 'Share this property';
  };

  const getShareIcon = (shareTitle) => {
    if (shareTitle === 'Email') {
      return <MailOutlineIcon testid={'shareEmailIcon'} fontSize={'medium'} className={styles.shareItemIcon} />;
    } else if (shareTitle === 'Facebook') {
      return <FacebookIcon testid={'shareFacebookIcon'} fontSize={'medium'} className={styles.shareItemIcon} />;
    } else if (shareTitle === 'Twitter') {
      return <TwitterIcon testid={'shareTwitterIcon'} fontSize={'medium'} className={styles.shareItemIcon} />;
    }
  };

  const trackShare = (action) => {
    propertyViewTracker(action.toLowerCase(), property);
  };

  const copyAddressLink = () => {
    const linkAddress = `https://${host}${pathname}`;
    setIsCopyLinkTooltipVisible(true);
    navigator.clipboard.writeText(linkAddress).then(() => {
      setTimeout(() => setIsCopyLinkTooltipVisible(false), 1000);
    });
  };

  const getShareView = (trackAction, shareLink, shareLinkTitle, shareTitle) => {
    return <a testid={`${shareTitle}Link`} className={styles.shareUrlLink} onClick={() => trackShare(trackAction)} href={shareLink} target="_blank" rel="noopener noreferrer nofollow" title={shareLinkTitle}>
      <div className={styles.shareItemContainer}>
        {getShareIcon(shareTitle)}
        <span testid={`${shareTitle}ShareLbl`} className={styles.shareItemText}>{shareTitle}</span>
      </div>
    </a>;
  };

  return <Popper
    testid={'shareDropdown'}
    anchorEl={() => ref.current}
    className={styles.popoverContainer}
    open={open}
    onClose={onCloseHandler}
    placement="bottom-end"
  >
    <ClickAwayListener onClickAway={onCloseHandler}>
      <div className={styles.popoverContentContainer}>
        <div className={styles.popoverContentTitleContainer}>
          <span testid={'shareModalTitleLbl'} className={styles.sharePropertyText}>{`${ property ? getSharePopupTitle(property.category) : 'Share this collection'}`}</span>
          <CloseIcon testid={'shareModalCloseIcon'} fontSize={'medium'} onClick={onCloseHandler}/>
        </div>
        {getShareView('share email', getEmailShareLink(isFromCollection ? collectionName : property.address.formattedAddress , isFromCollection,
          othShareUrl), 'Share via Email', 'Email')}
        {getShareView('share facebook', getFacebookShareLink(othShareUrl), 'Share on Facebook', 'Facebook')}
        {getShareView('share twitter', getTwitterShareLink(isFromCollection ? collectionName : property.address.formattedAddress,
          othShareUrl), 'Share on Twitter', 'Twitter')}
        <StyledTooltip id="copyLinkTooltipId" testid={'copyLinkTooltipTestId'} open={isCopyLinkTooltipVisible} title="Link Copied" placement="bottom-start">
          <div onClick={copyAddressLink} className={`${styles.shareItemContainer} ${styles.cursorPointer}`}>
            <LinkIcon testid={'copyLinkIcon'} fontSize={'medium'} className={styles.shareItemIcon}/>
            <span testid={'copyLinkShareLbl'} className={styles.shareItemText}>Copy Link</span>
          </div>
        </StyledTooltip>
      </div>
    </ClickAwayListener>
  </Popper>;
});

ShareDropdown.propTypes = {
  open: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  property: PropTypes.object,
  pathname: PropTypes.string,
  isFromCollection: PropTypes.bool,
  collectionName: PropTypes.string,
};

export default ShareDropdown;
